<template>
    <div class="inner lastModel">
        <span>XXX协会地址：xxxxx路88号</span>
        <span>备案序号：京ICP 备 888888888号</span>
    </div>
</template>

<script>
export default {

}
</script>

<style>
    .lastModel {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 0.4rem 0;
        font-weight: 700;
    }
    .lastModel span:first-child {
        margin-right: 0.5rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/ivew/lastModel.vue